/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { evaluate } from './conditions';

/**
 * @import { ConditionsEvaluationStrategy, TrackConditions } from '.'
 * @import { EvaluationError } from './errors'
 * @import { IVariablesNamespaceRegistry } from '../variables'
 */

/**
 * @param {TrackConditions} conditions
 * @returns {ConditionsEvaluationStrategy}
 */
export function getConditionsEvaluationStrategy(conditions) {
  switch (conditions.v) {
    case 'v1':
    default:
      return new ConditionsV1EvaluationStrategy();
  }
}

export class ConditionsV1EvaluationStrategy {
  /**
   * @param {TrackConditions} conditions
   * @param {IVariablesNamespaceRegistry} registry
   * @returns {boolean}
   */
  evaluate(conditions, registry) {
    try {
      /** @type {EvaluationError[]} */
      const warnings = [];
      if (!conditions.root) {
        return conditions.fallback;
      }
      const result = evaluate(conditions.root, registry, warnings);
      if (warnings.length > 0) {
        // TODO: Zatiaľ sa ignorujú.
      }
      return result;
    } catch {
      return conditions.fallback;
    }
  }
}
